<div class="farm-card" *ngIf="farm as f">
    <div class="farm-container">
        <div class="farm-header" (click)="toggleExpand()">
            <div class="farm-brand">
                <div class="logo-circle">{{ f.name.charAt(0) }}</div>
                <div class="title-block">
                    <h3 class="farm-name">{{ f.name }}</h3>
                    <p class="farm-address">{{ f.address }}</p>
                </div>
            </div>
            <div class="alert-badges">
                <span class="badge critical"
                    >{{ alerts.critical }} Critical</span
                >
                <span class="badge warning">{{ alerts.warning }} Warning</span>
                <span class="badge info">{{ alerts.info }} Info</span>
                <button
                    class="expand-btn"
                    (click)="$event.stopPropagation(); toggleExpand()"
                >
                    <span [class.rotated]="expanded">▾</span>
                </button>
            </div>
        </div>

        <div class="farm-stats-row">
            <div class="stat">
                <strong>{{ f.chicks | number }}</strong
                ><span>Number of Chicks</span>
            </div>
            <div class="stat">
                <strong>{{ f.mortalityPct | number: '1.1-2' }}%</strong
                ><span>Mortality %</span>
            </div>
            <div class="stat">
                <strong>{{ f.feedConsumption }}</strong
                ><span>Feed Consumption</span>
            </div>
            <div class="stat">
                <strong>{{ f.feedRemaining }}</strong
                ><span>Feed Remaining</span>
            </div>
            <div class="stat">
               <strong>{{ f.waterRemaining }}</strong>
                <span>Water Remaining</span>
            </div>  
             <div class="stat">
               <strong>{{ f.waterConsumption }}</strong>
                <span>Water Consumption</span>
            </div>           
            <div class="stat">
               <strong>{{ f.dieselRemaining }}</strong>
                <span>Diesel Remaining</span>
            </div>
            <div class="stat">
               <strong>{{ f.dieselConsumptionCycle }}</strong>
                <span>Diesel Consumption </span>
            </div>
            <div class="stat">
                <strong>{{ f.avgWeight | number: '1.1-2' }}g</strong
                ><span>Avg Weight</span>
            </div>

            <div class="stat">
                <strong>{{ f.outdoorTemperature | number: '1.1-2' }} °C</strong
                ><span>Outdoor Temperature</span>
            </div>

            <div class="stat">
                <strong>{{ f.outdoorHumidity | number: '1.1-2' }} %</strong
                ><span>Outdoor Humidity</span>
            </div>
        </div>
    </div>

    <div class="houses-wrapper" *ngIf="expanded">
        <ng-container *ngFor="let h of houses">
            <app-farm-overview-house-view
                *ngIf="h.name?.toLowerCase() !== 'house 0'"
                [house]="h"
            ></app-farm-overview-house-view>
        </ng-container>
        <ng-content></ng-content>
        <div class="no-houses" *ngIf="!houses.length">No houses</div>
    </div>
</div>
